// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xe8UKqIKe5QErnSi0Vdi{justify-content:space-between;align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"totalPlanDataLine": `Xe8UKqIKe5QErnSi0Vdi`
};
export default ___CSS_LOADER_EXPORT___;
